import { useQuery } from '@apollo/client';

import type { FilterConfig, Query } from '../../../../apis/graphql/types';
import { GET_TRAFFICKING_FILTER_CONFIG } from '../queries/getTraffickingFilterConfig';

type UseTraffickingFilterConfigResult = {
  filterConfigs: FilterConfig[];
  loading: boolean;
  error: Error | undefined;
};

export function useTraffickingFilterConfig(): UseTraffickingFilterConfigResult {
  const { data, loading, error } = useQuery<Pick<Query, 'getTraffickingFilterConfig'>>(GET_TRAFFICKING_FILTER_CONFIG);

  return {
    filterConfigs: data?.getTraffickingFilterConfig ?? [],
    loading,
    error,
  };
}
